/** Display names for attribution channels (attribution.source_channel keys).
 *  One source for the Marketing page and the ratio drill's channel dropdown. */
export const CHANNEL_LABELS: Record<string, string> = {
  meta_ads: "Meta (Facebook/Instagram)",
  google_ads: "Google Ads",
  tiktok_ads: "TikTok Ads",
  affiliate: "Affiliate",
  email: "Email",
  organic: "Organic",
  direct: "Direct",
  indirect: "Indirect",
  unknown: "Unknown",
};

export const channelLabel = (key: string): string => CHANNEL_LABELS[key] ?? key;
